module.exports = __webpack_public_path__ + "static/footer.dfbe84c7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/SpeakerSections/footer.svg
// module id = 709
// module chunks = 195234328731080